
  import { defineComponent } from 'vue';
  import { mapActions, mapGetters } from 'vuex';

  import PageTitle from '@/common/components/redesigned/PageTitle.vue';
  import ShowMoreButton from '@/common/components/redesigned/ShowMoreButton.vue';
  import constants from '@/common/constants';
  import security from '@/common/mixins/security';

  import Loader from '@/components/Loader.vue';

  import CountryCard from '../components/accountCochair/CountryCard.vue';
  import { PERSONAL_ACCOUNT_ACTIONS_NAME, PERSONAL_ACCOUNT_GETTERS_NAME } from '../store/personalAccount/name';

  export default defineComponent({
    name: 'PersonalAccountCochair',
    components: {
      PageTitle,
      CountryCard,
      Loader,
      ShowMoreButton,
    },
    mixins: [security],
    data(): {} {
      return {};
    },
    created() {
      this.checkPermissionAndRedirect(constants.Permissions.AccountCochairAccess);
      this.fetchCountries();
    },
    computed: {
      ...mapGetters({
        getCountries: PERSONAL_ACCOUNT_GETTERS_NAME.getListOfCountry,
        getIsLoading: PERSONAL_ACCOUNT_GETTERS_NAME.getIsLoading,
        getIsLoadingMore: PERSONAL_ACCOUNT_GETTERS_NAME.getIsLoadingMore,
      }),
    },
    methods: {
      ...mapActions({
        fetchCountries: PERSONAL_ACCOUNT_ACTIONS_NAME.fetchCountries,
        fetchMoreCountries: PERSONAL_ACCOUNT_ACTIONS_NAME.fetchMoreCountries,
      }),
      async handleMoreCountries() {
        await this.fetchMoreCountries({ params: { pageNumber: this.getCountries.pageNumber + 1 } });
      },
    },
  });
